enum CommunicationValueType {
    Other = 0,
    Personal = 1,
    Work = 2
}

export default CommunicationValueType;